import { getAvailableGiftCardBalance } from "./benefitBalance";

export const getDisplayBenefits = (benefits = [], giftCards = []) => {
  const giftCardBalance = getAvailableGiftCardBalance(giftCards);

  if (giftCardBalance <= 0) return benefits;

  return [
    ...benefits,
    {
      id: "gift-cards",
      name: "Tarjeta de Regalo",
      balances: [
        {
          name: "Balance Disponible",
          amount: giftCardBalance,
        },
      ],
    },
  ];
};
